import { useEffect, useState } from "react";
import ErrorLogout from "../../../helpers/ErrorLogout";
import { Button, Table, Tooltip } from "antd";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { getBidHistory } from "../../../api/AdminRequest";
// import { onShowSizeChange, itemRender } from "../common/TablePagination";
function BidHistory({ buyerID }) {


  const navigate = useNavigate();

  const [myBids, setMyBids] = useState([]);
  const [loader, setLoader] = useState([]);
  const [trigger, setTrigger] = useState(false);

  useEffect(() => {
    const bidsCall = async () => {
      try {
        setLoader(true);
        const { data } = await getBidHistory(buyerID);
        // console.log(data, 'data');

        if (data?.success) {
          setMyBids(data?.buyerBidList);
          setLoader(false);
        }
      } catch (error) {
        setLoader(false);
        console.log(error);
        console.log(error.message);
        if (error?.response?.status === 401) {
          ErrorLogout(error);
        }
      }
    };
    bidsCall();
  }, [trigger, buyerID]);
  const handleDetailedView = (bid) => {
    // console.log(bid);
    const bidID = bid._id
    navigate("/bid-detailed-view", { state: bidID  });
  };

  // const column = [
  //   {
  //     title: (
  //       <span className="text-[#4A4A4C] text-[14px] font-mediums">Sl.No</span>
  //     ),
  //     dataIndex: "_id",
  //     render: (text, record, index) => (
  //       <span className="text-[#878787] text-[16px] font-medium">
  //         {index + 1}
  //       </span>
  //     ),
  //     align: "center",
  //   },

  //   {
  //     title: (
  //       <span className="text-[#4A4A4C] text-[14px] font-mediums">Name</span>
  //     ),
  //     dataIndex: "bidID",
  //     render: (bidID) => (
  //       <span className="text-[#313131] font-semibold text-[16px]">
  //         {bidID?.productName}
  //       </span>
  //     ),

  //     sorter: (a, b) => a.name.localeCompare(b.name),
  //     align: "center",
  //   },

  //   {
  //     title: (
  //       <span className="text-[#4A4A4C] text-[14px] font-mediums">
  //         Category
  //       </span>
  //     ),
  //     dataIndex: "bidID",
  //     render: (bidID) => (
  //       <span className="text-[#878787] text-[16px] font-medium">
  //         {bidID?.category}
  //       </span>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: (
  //       <span className="text-[#4A4A4C] text-[14px] font-medium">Bid No</span>
  //     ),
  //     dataIndex: "bidID",
  //     render: (bidID) => (
  //       <span className="text-[#878787] text-[16px] font-medium">
  //         {bidID?.bidCount}
  //       </span>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: (
  //       <span className="text-[#4A4A4C] text-[14px] font-medium">Live Bid</span>
  //     ),
  //     dataIndex: "bidID",
  //     render: (bidID) => (
  //       <span className="text-[#878787] text-[16px] font-medium">
  //         {bidID?.bidLivePrice}
  //       </span>
  //     ),

  //     align: "center",
  //   },
  //   {
  //     title: (
  //       <span className="text-[#4A4A4C] text-[14px] font-mediums">
  //         Bid Amount
  //       </span>
  //     ),
  //     dataIndex: "bids",
  //     render: (bids) => (
  //       <span className="text-[#878787] text-[16px] font-medium">
  //         {bids[bids.length - 1]?.amount}
  //       </span>
  //     ),
  //     align: "center",
  //   },
  //   {
  //     title: (
  //       <span className="text-[#4A4A4C] text-[14px] font-mediums">
  //         Bid Count
  //       </span>
  //     ),
  //     dataIndex: "bids",
  //     render: (bids) => (
  //       <span className="text-[#878787] text-[16px] font-medium">
  //         {bids.length}
  //       </span>
  //     ),

  //     align: "center",
  //   },
  //   Table.EXPAND_COLUMN,
  //   {
  //     title: (
  //       <span className="text-[#4A4A4C] text-[14px] font-mediums">Status</span>
  //     ),
  //     dataIndex: "bidID",
  //     render: (bidID) => {
  //       const status =
  //         moment(bidID?.bidEnd) > Date.now()
  //           ? "Live"
  //           : bidID?.currentBider === buyerID
  //           ? "Won"
  //           : "Expired";
  //       const statusClass =
  //         status === "Live"
  //           ? "text-[#01A208] text-[16px] font-medium"
  //           : status === "Won"
  //           ? "text-[#F08200] text-[16px] font-medium"
  //           : "text-[#878787] text-[16px] font-medium";
  //       return <span className={statusClass}>{status}</span>;
  //     },
  //     align: "center",
  //   },

  //   {
  //     title: (
  //       <span className="text-[#4A4A4C] text-[14px] font-mediums">
  //         Date & Time
  //       </span>
  //     ),
  //     dataIndex: "createdDate",
  //     render: (createDate) => (
  //       <span className="text-[#878787] text-[16px] font-medium">
  //         {moment(createDate).format("DD/MM/YYYY HH:mm")}
  //       </span>
  //     ),
  //     align: "center",
  //   },

  //   {
  //     title: (
  //       <span className="text-[#4A4A4C] text-[14px] font-mediums">Actions</span>
  //     ),
  //     dataIndex: "status._id",
  //     align: "center",
  //     render: (status, _id) => (
  //       <>
  //         <div className="gap-2 flex">
  //           <button
  //             className="cursor-pointer bg-[#1955EB] font-semibold text-[16px] px-3 text-white rounded-md  py-2 mr-2"
  //             onClick={() => handleDetailedView(_id.bidID)}
  //           >
  //             View Detail
  //           </button>
  //         </div>
  //       </>
  //     ),
  //   },
  // ];
  
  const checkTopBidder = (bids) => {
    const lastTwoBids = bids.slice(-2);
    return lastTwoBids.some(bid => bid.userID === buyerID);
  }
  const column = [
    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Sl.No</span>
      ),
      dataIndex: "_id",
      render: (text, record, index) => (
        <span className="text-[#878787] text-[16px] font-medium">
          {index + 1}
        </span>
      ),
      align: "center",
    },

    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Name</span>
      ),
      dataIndex: "bidID",
      render: (bidID) => (
        <span className="text-[#313131] font-semibold text-[16px]">
          {bidID?.productName}
        </span>
      ),

      sorter: (a, b) => a.name.localeCompare(b.name),
      align: "center",
    },

    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-medium">
          Current Bid
        </span>
      ),
      dataIndex: "bidID",
      render: (bidID) => (
        <span className="text-[#878787] text-[16px] font-medium">
          {bidID?.bidLivePrice}
        </span>
      ),

      align: "center",
    },

    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">
          Bid Count
        </span>
      ),
      dataIndex: "bids",
      render: (bids) => (
        <span className="text-[#878787] text-[16px] font-medium">
          {bids.length}
        </span>
      ),

      align: "center",
    },
    Table.EXPAND_COLUMN,
    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Status</span>
      ),
      dataIndex: "bidID",
      render: (bidID) => {
        const status =
          moment(bidID?.bidEnd) > Date.now()
            ? "Live"
            : bidID?.currentBider === buyerID
              ? "Won"
              : "Expired";
        const statusClass =
          status === "Live"
            ? "text-[#01A208] text-[16px] font-medium"
            : status === "Won"
              ? "text-[#F08200] text-[16px] font-medium"
              : "text-[#878787] text-[16px] font-medium";
        return <span className={statusClass}>{status}</span>;
      },
      align: "center",
    },

    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">
          Last Bid
        </span>
      ),
      dataIndex: "bids",
      render: (bids) => (
        <span className="text-[#878787] text-[16px] font-medium">
          {bids.length === 0 ? 'NA' : moment(bids[bids.length - 1]?.createDate).format("DD MMM YYYY HH:mm")}
        </span>
      ),
      align: "center",
    },

    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Actions</span>
      ),
      dataIndex: "status._id",
      align: "center",
      render: (status, _id) => (
        <>
          <div className="gap-2 flex">
            <Button
              className=" h-10 cursor-pointer bg-[#1955EB] font-semibold text-[16px] px-3 text-white rounded-md  py-2 mr-2"
              onClick={() => handleDetailedView(_id.bidID)}
            >
              View Product
            </Button>
            {/* {
              moment(_id.bidID?.bidEnd) < Date.now() &&
                _id.bidID?.currentBider === buyerID ? (
                <Button
                  className="h-10 cursor-pointer bg-white border-[1px] text-[16px] border-[#1955EB] px-3 text-white rounded-md  py-2"
                  onClick={() => showReviewModal(_id.bidID)}
                >
                  Review Bid
                </Button>
              ) : moment(_id.bidID?.bidEnd) > Date.now() ? (
                _id.bids.length === 0
                  // || !checkTopBidder(_id.bids)
                  ? (
                    <Button
                      className="h-10 cursor-pointer border-[#FF4545] border-[1px] text-[16px] font-semibold text-[#FF4545] rounded-md px-4 py-2"
                      onClick={() => {
                        handleCancelBid(_id);
                      }}
                    >
                      Cancel Bid
                    </Button>
                  ) : (
                    <Tooltip
                      title={"Bids in top 2 positions cannot be canceled."}
                    >
                      {" "}
                      <Button disabled className="h-10  cursor-pointer text-[#FF4545] text-[16px] px-4 font-semibold border-[#FF4545] border-[1px] rounded-md  py-2">
                        Cancel Bid
                      </Button>
                    </Tooltip>
                  )
              ) : (
                ""

              )} */}
          </div>
        </>
      ),
    },
  ];

  const columns = [
    {
      title: "Count",
      dataIndex: "bidCount",
      key: "bidCount",
    },
    {
      title: "Buyer",
      dataIndex: "userID",
      key: "userID",
      render: (text) => <a>{text === buyerID ? "This Buyer" : "Other Buyer"}</a>,
    },

    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Created At",
      dataIndex: "createDate",
      key: "createDate",
      render: (text) => <a>{moment(text).format("DD/MM/YYYY HH:MM")}</a>,
    },
  ];


  return (
    <div className="container">
      {/* <div className="shadow-lg hover:shadow-xl rounded-xl mt-4 overflow-x-auto">
        <Table
          className="min-w-full divide-y divide-gray-200"
          //   pagination={{
          //     total: myBids?.length,
          //     showTotal: (total, range) =>
          //       `Showing ${range[0]} to ${range[1]} of ${total} entries`,
          //     showSizeChanger: true,
          //     onShowSizeChange: onShowSizeChange,
          //     itemRender: itemRender,
          //   }}
          columns={column}
          loading={loader}
          dataSource={myBids}
          rowKey={(record) => record._id}
          expandable={{
            expandedRowRender: (record) => (
              <p
                style={{
                  margin: 0,
                }}
              >
                {record.bids.map((bid, index) => {
                  return (
                    <div className="flex justify-between mb-2" key={index}>
                      <p>{index + 1}</p>
                      <p>Bid Count: {bid.bidCount}</p>
                      <p>Bid Amount: {bid.amount}</p>
                      <p>
                        Created Date:
                        {moment(bid.createDate).format("DD/MM/YYYY HH:MM")}
                      </p>
                    </div>
                  );
                })}
              </p>
            ),
          }}
        />
      </div> */}

      <div className="shadow-lg hover:shadow-xl rounded-xl mt-4 overflow-x-auto">
        <Table
          className="min-w-full divide-y divide-gray-200"
          pagination={{
            total: myBids?.length,
            showTotal: (total, range) =>
              `Showing ${range[0]} to ${range[1]} of ${total} entries`,
            showSizeChanger: true,
            // onShowSizeChange: onShowSizeChange,
            // itemRender: itemRender,
          }}
          columns={column}
          loading={loader}
          dataSource={myBids}
          rowKey={(record) => record._id}
          expandable={{
            expandedRowRender: (record) => (
              <Table className=" divide-y divide-gray-200" columns={columns} dataSource={record.bids} />
            ),
          }}
        />
      </div>
    </div>
  );
}

export default BidHistory;
